module.exports = __webpack_public_path__ + "static/redux-528bfe4df036d317c6a9e219c8b59f9c.png";